import clsx from 'clsx'
import React, { ReactNode } from 'react'

import cl from './CallMe.module.scss'

const CallMe: React.FC<{ body?: ReactNode; className?: string }> = ({ body, className }) => {
	return (
		<section className={clsx(cl.callMe, className)}>
			<div className={cl.callMe__textWrapper}>
				<h2 className={cl.callMe__title}>Остались вопросы?</h2>
				<p className={cl.callMe__subtitle}>{body}</p>
			</div>
			<a href="tel:8(812)318-38-38" className={cl.callMe__tel}>
				8 (812) 318-38-38
			</a>
		</section>
	)
}

export default CallMe
